import condutor from './condutor';
import destino from './destino';
import jornada from './jornada';
import veiculo from './veiculo';
import ponto from './ponto';
import grupo from './grupo';
import motivo from './motivo';
import preAgendamento from './preAgendamento';
import parametrizacao from './parametrizacao';
import agendar from './agendar';
import supervisor from './supervisor';
import listagem from './listagem';
import alterarHorarioSaida from './alterarHorario';
import escolher from './escolher';
import transferencia from './transferencia';
import fechamento from './fechamento';
import gerenciamento from './gerenciamento';
import reimpressaoProtocolo from './reimpressaoProtocolo';
import relatorioAgendador from './relatorioAgendador';
import relatorioViagem from './relatorioViagem';
import relatorioEstatistico from './relatorioEstatistico';
import relatorioQuantitativo from './relatorioQuantitativo';
import relatorioViagemVeiculo from './relatorioViagemVeiculo';
import relatorioViagemMotorista from './relatorioViagemMotorista';
import relatorioViagemGeral from './relatorioViagemGeral';
import relatorioViagemData from './relatorioViagemData';
import relatorioPrestacaoConta from './relatorioPrestacaoConta';
import reaberturaViagem from './reaberturaViagem';

export default [
    {
        path: 'transporte-paciente',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...condutor,
            ...veiculo,
            ...destino,
            ...jornada,
            ...ponto,
            ...grupo,
            ...motivo,
            ...preAgendamento,
            ...parametrizacao,
            ...agendar,
            ...supervisor,
            ...listagem,
            ...alterarHorarioSaida,
            ...escolher,
            ...transferencia,
            ...fechamento,
            ...gerenciamento,
            ...reimpressaoProtocolo,
            ...relatorioAgendador,
            ...relatorioViagem,
            ...relatorioEstatistico,
            ...relatorioQuantitativo,
            ...relatorioViagemVeiculo,
            ...relatorioViagemMotorista,
            ...relatorioViagemData,
            ...relatorioViagemGeral,
            ...relatorioPrestacaoConta,
            ...reaberturaViagem,
        ]
    }
]